import { render, staticRenderFns } from "./StakeStatsNew.vue?vue&type=template&id=79b7e02d&scoped=true&lang=html&"
import script from "./StakeStatsNew.vue?vue&type=script&lang=js&"
export * from "./StakeStatsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7e02d",
  null
  
)

export default component.exports